export const notificationKeys = {
  all: ["notifications"] as const,

  header: () => [...notificationKeys.all, "header"] as const,

  alerts: () => [...notificationKeys.all, "alerts"] as const,

  pageAll: () => [...notificationKeys.all, "page"] as const,

  page: (filters: {
    current: number;
    limit_to: number;
    is_read?: boolean;
    is_starred?: boolean;
  }) => [...notificationKeys.all, "page", filters] as const,

  preferences: (orgName: string) =>
    [...notificationKeys.all, "preferences", orgName] as const,

  livisUsers: (orgName: string) =>
    [...notificationKeys.all, "livisUsers", orgName] as const,

  alertTriggerPreferences: (orgName: string) =>
    [...notificationKeys.all, "alertTriggerPreferences", orgName] as const,
};
